// POM-6561 - the REASONS cell of an offage record. The reasons alone when one entry covers the
// whole record ("Damaged"); otherwise each entry with its quantity ("2 Missing · 1 Damaged"), so
// a partial entry never reads as the whole record.
const formatOffageReasons = (offageReasons, recordQty) => {
  const entriesWithReasons = (offageReasons ?? []).filter((entry) => entry.reasons?.length > 0);

  if (entriesWithReasons.length === 1 && entriesWithReasons[0].qty === recordQty) {
    return entriesWithReasons[0].reasons.join(', ');
  }

  return entriesWithReasons.map((entry) => `${entry.qty} ${entry.reasons.join(', ')}`).join(' · ');
};

export default formatOffageReasons;
